 <template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Claim No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <form data-vv-scope="queryClmFilterForm">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg6 xs12>
                            <v-text-field
                              data-vv-scope="queryClmFilterForm"
                              v-model="filtersClm.claimNo"
                              :label="filtersClmLabel.claimNo"
                              :error-messages="errors.collect('filterClm')"
                              data-vv-name="filterClm"
                              :data-vv-as="filtersClmLabel.claimNo"
                              v-validate="'entry|max:20'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions right>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearClmFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.prevent="doClmFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
        <v-flex xs12 class="mt-2">
          <v-card>
            <v-card-text>
              <v-data-table
                class="elevation-1"
                v-bind:headers="clmHeaders"
                v-bind:items="items"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItemsClm"
                v-bind:options.sync="paginationClm"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', 'clmNo')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', 'clmNo')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      items: [],
      totalItemsClm: 0,
      filtersClmLabel: {
        claimNo: 'Claim No.'
      },
      filtersClm: {
        claimNo: undefined,
        accountNo: null
      },
      clmHeaders: [
        // { text: '', value: 'branch', cellClass: 'check-box-class' },
        { text: 'Branch', align: 'left', value: 'branch' },
        { text: 'Claim No.', align: 'left', value: 'claimNo' },
        { text: 'Policy No.', align: 'left', value: 'policyNo' },
        { text: 'Insured Name', align: 'left', value: 'insured' }
      ],
      paginationClm: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    // this.doClearClmFilters()
    this.doFetchClmData()
  },
  watch: {
    boolRefresh: function (value) {
      if (value) {
        this.doClearClmFilters()
      }
    },
    'paginationClm': function (value) {
      this.doFetchClmData()
    }
  },
  methods: {
    doFilterOnEnter() {
      this.doClmFilters()
      event.preventDefault()
    },
    closeDialog() {
      this.filtersClm.claimNo = ''
      this.$emit('close')
    },
    doClearClmFilters() {
      this.filtersClm.claimNo = ''
      this.filtersClm.accountNo = this.accountNo
      this.doFetchClmData()
    },
    doClmFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryClmFilterForm').then((result) => {
        if (result) {
          this.paginationClm.page = 1
          this.filtersClm.accountNo = this.accountNo
          this.doFetchClmData()
        }
      })
    },
    assignClaimNo(data) {
      // Use $emit to call parent Accounts page method assignClaimNo and pass the value
      this.$emit('assign-claim-no', data.clmNo)
      this.$emit('close')
    },
    async doFetchClmData() {
      const apiUrl = this.$store.state.commons.menu.clmList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationClm
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          let massageFilters = clone(this.filtersClm)
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationClm.sortBy, this.paginationClm.sortDesc))
          if (result.data) {
            this.items = []
            this.totalItemsClm = result.data.totalElements
            const { data } = result.data
            data.map((clmObj) => {
              const convertObj = {
                key: clmObj.clmNo,
                value: clmObj.clmNo,
                claimNo: clmObj.clmNo,
                branch: clmObj.branch,
                policyNo: clmObj.polNo,
                insured: clmObj.insdName1
              }
              this.items.push(convertObj)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {},
  props: {
    boolRefresh: {
      type: Boolean,
      default: true
    },
    accountNo: {
      type: String,
      default: ''
    },
    menu: Object
  },
  mixins: [TableConst.default, commonAjaxMixin, helpListMixin]
}
</script>

<style>
.check-box-class {
  color: white;
}
</style>
